import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setErr("");
    try { await login(email, password); toast.success("Welcome back."); navigate("/admin"); }
    catch (e) { setErr(formatApiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] bg-[var(--lt-bg)] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><Logo size="md" /></div>
        <div className="border border-[var(--lt-border)] bg-[var(--lt-panel)] p-8" data-testid="login-form">
          <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-2">// Dispatch Login</div>
          <h1 className="font-display font-black text-3xl text-white uppercase">Admin Access</h1>
          <p className="text-slate-400 text-sm mt-2">Sign in to the Lucas Trans dispatch dashboard.</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <Label className="text-xs font-mono-lt uppercase tracking-[0.2em] text-slate-400 mb-2 block">Email</Label>
              <Input required type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[var(--lt-bg)] border-[var(--lt-border)] rounded-xl h-11" />
            </div>
            <div>
              <Label className="text-xs font-mono-lt uppercase tracking-[0.2em] text-slate-400 mb-2 block">Password</Label>
              <Input required type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[var(--lt-bg)] border-[var(--lt-border)] rounded-xl h-11" />
            </div>
            {err && <div className="text-sm text-red-400 border border-red-900 bg-red-950/30 p-3" data-testid="login-error">{err}</div>}
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[var(--lt-accent)] hover:bg-[var(--lt-accent-hover)] text-white rounded-xl h-12 font-head uppercase tracking-widest text-sm">{loading ? "Signing in…" : "Sign In"}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
